(function ($) {
	const blockSlug = 'hometop';
	const initializeBlock = function ($block) {

		// START your JS code
		gsap.registerPlugin(ScrollTrigger);
		const homeTop = jQuery('.acf-block-hometop');
		const logo = jQuery('.acf-block-hometop__logo');
		const cta = jQuery('.acf-block-hometop__cta');
		const image = jQuery('.acf-block-hometop__bg-image_wrapper');

		ScrollTrigger.create({
			trigger: logo,
			start: "center center",
			//end: "+=" + (window.innerHeight),
			//endTrigger: ".acf-block-hometop__logo",
			pin: true,
			end: "bottom center",
			//markers: true,
		});

		ScrollTrigger.create({
			trigger: cta,
			start: "bottom top",
			endTrigger: cta,
			end: "bottom center",
			pin: true,
			//markers: true,
		});

		ScrollTrigger.create({
			trigger: image,
			start: "top top",
			endTrigger: homeTop,
			end: "bottom bottom",
			pin: true,
			//markers: true,
		});

		// END your JS code
	};

	// Initialize each block on page load (front end).
	jQuery(window).on('load', function () {
		$('.acf-block-' + blockSlug).each(function () {

			initializeBlock($(this));

		});
	});
	/*jQuery(window).on('load',function () {
		$('.acf-block-' + blockSlug).each(function () {
			const blockHeight = jQuery(this).outerHeight();
			const blockWrapperHeight = jQuery(this).find('.wrapper').outerHeight();
			console.log(blockHeight);
			console.log(blockWrapperHeight);
		});
	});*/

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=' + blockSlug, initializeBlock);
	}
})(jQuery);
